export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/web_banners.ea25399.svg";